import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity("competency_code")
export class CompetencyCode {
  @PrimaryGeneratedColumn({ type: "int", name: "id" })
  id: number;

  @Column("varchar", { name: "code", length: 255, nullable: true })
  code: string | null;

  @Column("tinyint", { name: "status", default: () => '1' })
  status: number;
}
